'use client'

import Box from '@mui/material/Box'
import { ReactElement } from 'react'
import Skeleton from '../Skeleton/Skeleton'

export default function TimelineSkeleton(): ReactElement {
    return (
        <>
            <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                <Skeleton width="20px" />
                <Box sx={{ ml: 2 }}>
                    <Skeleton width="100px" />
                    <Skeleton width="60px" />
                </Box>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'flex-start', mt: 2 }}>
                <Skeleton width="20px" />
                <Box sx={{ ml: 2 }}>
                    <Skeleton width="100px" />
                    <Skeleton width="60px" />
                </Box>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'flex-start', mt: 2 }}>
                <Skeleton width="20px" />
                <Box sx={{ ml: 2 }}>
                    <Skeleton width="100px" />
                    <Skeleton width="60px" />
                </Box>
            </Box>
        </>
    )
}
